import React from "react";
import { useNavigate } from "react-router-dom";

const Pagenotfound = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center", // vertical center
      alignItems: "center", // horizontal center
      height: "100%", // full viewport height
      width: "100%", // full viewport width
      textAlign: "center",
      backgroundColor: "#f0f2f5",
      padding: "20px",
      boxSizing: "border-box", // padding included in size
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    gif: {
      maxWidth: "350px",
      width: "100%",
      marginBottom: "30px",
      borderRadius: "12px",
      boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
    },
    heading: {
      fontSize: "3rem",
      color: "#222",
      marginBottom: "15px",
      fontWeight: "700",
      textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
    },
    paragraph: {
      fontSize: "1.25rem",
      color: "#555",
      marginBottom: "30px",
      maxWidth: "420px",
      lineHeight: "1.6",
    },
    button: {
      padding: "12px 30px",
      fontSize: "1.1rem",
      color: "#fff",
      backgroundColor: "#9c6b2f",
      border: "none",
      borderRadius: "25px",
      cursor: "pointer",
      transition: "background-color 0.3s ease, transform 0.2s ease",
      boxShadow: "0 5px 15px rgba(0,123,255,0.4)",
      userSelect: "none",
    },
  };

  const [hover, setHover] = React.useState(false);

  return (
    <div style={styles.container}>
      <img
        src="https://media.giphy.com/media/UoeaPqYrimha6rdTFV/giphy.gif"
        alt="404 Not Found"
        style={styles.gif}
      />
      <h1 style={styles.heading}>Oops! Page Not Found</h1>
      <p style={styles.paragraph}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <button
        style={{
          ...styles.button,
          backgroundColor: hover ? "#0d5fa9" : "#0d5fa9",
          transform: hover ? "scale(1.05)" : "scale(1)",
        }}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={() => navigate("/")}
      >
        Go Back Home
      </button>
    </div>
  );
};

export default Pagenotfound;
